import $ from 'jquery';

const initNavigationMenuButton = () => {
	if (window.innerWidth > 992) {
		return;
	}

	$('.nav-bar > .menu-btn').on('click', (e) => {
		$(e.target.parentNode).toggleClass('-active');
	});
};

export default initNavigationMenuButton;



// WEBPACK FOOTER //
// ./src/js/common/initNavigationMenuButton.js